import React from 'react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {ITranslate} from '../../../../../services/LocalizationService';
import {observer} from 'mobx-react';

interface ScanResultHeaderProps {
    textHeader: string;
    id: string;
    date?: Date;
    translate: ITranslate;
}

@observer
export class ScanResultHeader extends TechseeBaseComponent<ScanResultHeaderProps> {
    renderInternal() {
        const {textHeader, id, date, translate} = this.props;

        return (
            <div className='scan-result-header-container'>
                <h2 className='scan-header'>{textHeader} </h2>
                <div className='scan-inner-data-container'>
                    <div className={'scan-inner-data-wrapper'}>
                        <p className={'scan-name'}>{translate('CONNECTIVITY_GURU.WIFI_SCAN.SCAN_ID')}</p>
                        <p className={'scan-text'}>{id}</p>
                    </div>

                    <div className={'scan-inner-data-wrapper'}>
                        <p className={'scan-name'}>{translate('CONNECTIVITY_GURU.WIFI_SCAN.SCAN_PERFORMED_ON')}</p>
                        <p className='scan-text'>
                            {date &&
                                new Date(date)
                                    .toLocaleString('en-US', {
                                        hour: 'numeric',
                                        minute: '2-digit',
                                        hour12: true,
                                        day: 'numeric',
                                        month: 'long',
                                        year: 'numeric'
                                    })
                                    .replace(',', '')}
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}
